import { Injectable } from '@angular/core';
import {
  CanActivate,
  Router,
  UrlTree,
} from '@angular/router';
import { map, Observable } from 'rxjs';
import { HealthService } from '../services/health/health.service';

@Injectable({
  providedIn: 'root',
})
export class HealthCheckGuard implements CanActivate {
  constructor(private router: Router, private healthService : HealthService) {}

  canActivate():
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    return this.healthService.isHealthy().pipe(
      map((response) => {
        if (response?.healthy === false) {
          return this.router.parseUrl('/maintenance');
        }
        if (response?.healthy === true) {
          return true;
        }
        return true;
      })
    );
  }
}
